import { render, staticRenderFns } from "./BioCard.vue?vue&type=template&id=72946b64&scoped=true&"
import script from "./BioCard.vue?vue&type=script&lang=js&"
export * from "./BioCard.vue?vue&type=script&lang=js&"
import style0 from "./BioCard.vue?vue&type=style&index=0&id=72946b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72946b64",
  null
  
)

export default component.exports